if (!customElements.get('arcana-notify-me')) {
  customElements.define(
    'arcana-notify-me',
    class ArcanaNotifyMe extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section || !data.html) return;
          const fresh = data.html.getElementById(this.id);
          if (fresh) this.innerHTML = fresh.innerHTML;
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    }
  );
}
